<template>
    <div class="col-sm-12 col-md-6">
              <div class="card">
                <div class="card-header">
                  <h5>Dropdown With DropUp</h5><span>Use a class <code>.drop-up</code></span>
                </div>
                <div class="card-body dropup-basic dropdown-basic">
                  <div class="dropup dropdown">
                    <button class="dropbtn btn-primary" type="button">Dropdown Button <span><i class="icofont icofont-arrow-up"></i></span></button>
                    <div class="dropup-content dropdown-content"><a href="#">Link 1</a><a href="#">Link 2</a></div>
                  </div>
                </div>
              </div>
            </div>
</template>